module.exports = __webpack_public_path__ + "static/media/glass6.1a87ee76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass6.png
// module id = 731
// module chunks = 0